import styled from "@emotion/styled";
import {
  fontMerriweather,
  fontRoboto,
  fontRobotoCondensed,
  transientOptions,
} from "@product/scmp-sdk";

import { AuthorAvatar } from "~/components/author/author-avatar";
import { AuthorName } from "~/components/author/author-name";
import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)``;

export const Container = styled.div`
  ${StyledEntityLink} {
    color: #000000;
  }
  &:hover {
    ${StyledEntityLink} {
      color: #2c4692;
    }
  }
`;

export const Header = styled.div`
  color: #000000;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 22px;
`;

export const Content = styled.div`
  margin-block-start: 8px;

  color: #666666;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
`;

export const Footer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  margin-block-start: 12px;

  color: #999999;
  font-size: 12px;
  font-family: ${fontRoboto};
`;

export const Author = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  margin-block-start: 12px;
`;

export const AuthorNameContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const AuthorAvatarContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledAuthorTitle = styled.div`
  margin-block-end: 3px;

  color: #000000;
  font-weight: 900;
  font-size: 14px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 16px;
`;

export const StyledAuthorName = styled(AuthorName)`
  color: #000000;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  &:hover {
    text-decoration: none;
  }
`;

type AuthorAvatarProps = {
  $isBordered?: boolean;
};

export const StyledAuthorAvatar = styled(AuthorAvatar, { ...transientOptions })<AuthorAvatarProps>`
  border: ${props => (props.$isBordered ? `#34b8b5 2px solid` : "unset")};

  & {
    inline-size: 44px;
    block-size: 44px;

    border-radius: 40px;
  }

  & + & {
    z-index: -1;

    margin-inline-start: -10px;
  }

  img {
    inline-size: 40px;
    block-size: 40px;
  }
`;
